import { REFERRAL_API } from "../../../utils/constants/apis.urls";
import { axiosInstance } from "../../../config/interceptor";

export const registerReferral = (data: FormData) => {
  return axiosInstance.post(REFERRAL_API.REFFERAL_FORM, data);
}
